import { connect } from 'react-redux';
import GoalYearView from './GoalYearView';
import { goalId as selectedGoalId } from '../../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../../WhatIfsRouteDictionary';

import {
  yearsOptionsSelector,
  yearSelector,
  RETIREMENT,
} from './GoalYearSelector';

import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
} from '../../../WhatIfsActions';

import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
} from '../../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  options: yearsOptionsSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  value: yearSelector(state, ownProps),
  id: 'GoalYear',
  label: 'Desired Start Year',
  valueStorePath: 'WhatIf.Year',
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatifType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatifType, data));
  },
  saveYearGoal: (clientId, goalId, whatifType) => (selection) => {
    if (selection) {
      const { value } = selection;
      const isRetirement = value === RETIREMENT;

      const WhatIf = {
        StartAtRetirement: isRetirement,
      };

      if (!isRetirement) {
        WhatIf.Year = value;
      }

      dispatch(updateWhatIfsData(clientId, goalId, whatifType, { WhatIf }));
    }
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(planImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(initialPlanImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchData: (clientId, fpId, goalId, whatifType) => {
    dispatch(fetchWhatIfOptions(
      clientId,
      fpId,
      goalId,
      RouteDictionary[whatifType],
      whatifType,
    ));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(applyWhatIf(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GoalYearView);
